import pdpStateManager from '@src/quince-site-common/src/redux/globalStateManager/PDPStateManager'

export const showReviewSection = () => {
  pdpStateManager.setShowReviewSection({ reviewSectionInFocus: true })
}
